import {
  ChangeDetectionStrategy,
  ChangeDetectorRef,
  Component,
  OnDestroy,
  OnInit,
  ViewChild
} from '@angular/core';
import { select, Store } from '@ngrx/store';
import { Subscription } from 'rxjs';

import { State } from '../../../../vista-usuario/vista-usuario.state';

import { ROUTE_ANIMATIONS_ELEMENTS } from '../../../../../core/core.module';

import { FormActionType } from '@rpe/registro-personas-empresas-lib';

import { entityTecnicoResponsableAddRequest } from '../../entity-tecnico-responsable.actions';

import { filter } from 'rxjs/operators';

import { Router } from '@angular/router';
import { selectAuthPersona } from '../../../../persona/entity-personas/entity-personas.selectors';
import {
  TecnicoResponsable,
  TecnicoResponsableFormInput
} from '../../entity-tecnico-responsable.model';
import { TecnicoResponsableFormComponent } from '../tecnico-responsable-form/tecnico-responsable-form.component';
import { Persona } from '../../../../persona/entity-personas/entity-personas.model';
import {
  DireccionGeografica,
  createEmptyDireccionGeografica
} from '../../../../ubicaciones/direcciones-geograficas/direcciones-geografica.model';

@Component({
  selector: 'rpe-entity-tecnico-responsable-form-container',
  templateUrl: './entity-tecnico-responsable-form-container.component.html',
  styleUrls: ['./entity-tecnico-responsable-form-container.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class EntityTecnicoResponsableFormContainerComponent
  implements OnInit, OnDestroy
{
  routeAnimationsElements = ROUTE_ANIMATIONS_ELEMENTS;

  @ViewChild(TecnicoResponsableFormComponent)
  tecnicoResponsableForm: TecnicoResponsableFormComponent;

  formValid = false;
  formValue: TecnicoResponsable;
  persona: Persona;

  auxDG: DireccionGeografica = createEmptyDireccionGeografica();

  subscription: Subscription;

  // mover el form input para donde corresponda
  formInput: TecnicoResponsableFormInput = {
    action: FormActionType.Add,
    tipos_documento: null,
    paises: null,
    localidades: null,
    departamentos: null,
    direcciones_geografica_IDE: null,
    direccion_geografica: createEmptyDireccionGeografica(),
    persona: null
  };

  constructor(
    public store: Store<State>,
    private ref: ChangeDetectorRef,
    private router: Router
  ) {}

  ngOnInit(): void {
    this.subscription = this.store
      .pipe(
        select(selectAuthPersona),
        filter((personas) => !!personas)
      )
      .subscribe((persona) => {
        this.persona = persona;
        this.formInput = {
          action: FormActionType.Add,
          tipos_documento: null,
          paises: null,
          localidades: null,
          departamentos: null,
          direcciones_geografica_IDE: null,
          direccion_geografica: persona.direccion_geografica,
          persona: persona
        };
        this.ref.detectChanges();
      });
  }

  ngOnDestroy(): void {
    this.subscription.unsubscribe();
  }

  formStatusChanges(status: string) {
    this.formValid = status === 'VALID';
  }

  formValueChanges(tecnicoResponsable: TecnicoResponsable) {
    this.formValue = tecnicoResponsable;
  }

  onSubmit() {
    if (this.formValid) {
      if (this.formInput.action === FormActionType.Add) {
        this.formValue.tecnico = {
          ...this.formValue.tecnico,
          tipo_tecnico_id: 1,
          persona_id: this.persona.id,
          acreditado: 1,
          habilitado: 1
        };
        this.store.dispatch(
          entityTecnicoResponsableAddRequest({
            item: this.formValue
          })
        );
      }
    } else {
      this.tecnicoResponsableForm.onShowErrors();
    }
  }

  onCancel() {
    this.router.navigate(['/main', 'landing']);
  }
}
